import React from 'react'
import { ResetFormBody } from './style'
import { useAppDispatch } from 'store/store'
import { FormTypes } from 'types/enums/EFormTypes'
import { useTranslation } from 'react-i18next'
import { setForm } from 'store/reducers/layoutReducer'
import { setFormTranslatedText } from 'pages/auth/utils/setFormTranslatedText'
import { Button } from 'shared/components/button/Button'

export const ResetPasswordSuccess: React.FC = () => {
  const dispatch = useAppDispatch()
  const page = 'resetPassword.success'
  const { t } = useTranslation('', {
    keyPrefix: `pages.${page}`,
  })

  setFormTranslatedText(page)

  return (
    <ResetFormBody>
      <Button
        type="submit"
        text={t(`buttons.login.text`)}
        callback={() => dispatch(setForm({ formType: FormTypes.LOGIN_FORM }))}
      />
    </ResetFormBody>
  )
}
